<template>
  <div class="layout appMain">
    <Layout style="display: flex; flex-direction: column">
      <Header v-show="topHeadShow">
        <Menu mode="horizontal" theme="dark" active-name="1">
          <div class="layout-logo">
            <a href="http://cetproduct.cctv.cn/portal" target="_blank" class="back-to-home">
              <img :src="logoImg" :alt="$t('pub.notLoad')">
            </a>
          </div>
          <div class="layout-nav">
            <span class="lang">
              <svg class="icon" aria-hidden="true" @click="toggleLang('zh')" v-show="$i18n.locale == 'en'">
                <use xlink:href="#icon-zhongwen"></use>
              </svg>
              <svg class="icon" aria-hidden="true" @click="toggleLang('en')" v-show="$i18n.locale == 'zh'">
                <use xlink:href="#icon-yingwen"></use>
              </svg>
            </span>
            <span class="fengexian"></span>
            <MenuItem name="4">
            <!-- <span>您好，</span> -->
            <img src="../../../static/assets/common/images/cctv/user.png" alt="" class="userImg">
            <span>{{tenantName}}</span>
            <!-- <div class="user-info">
              <span>{{userName}}</span>
              <i></i>
              <ul>
                <li><a   target="_blank" @click="openOuterPage(userUrl);return false">用户中心</a></li>
                <li><a   target="_blank" @click="openOuterPage(accountUrl);return false">费用中心</a></li>
                <li><a :href="$router.history.base+'/AI/speechRecognition'" target="_blank">AI任务中心</a></li>
                <li><a @click="logout();return false;">退出</a></li>
              </ul>
            </div> -->
            <Dropdown class="main-drop">
                <a href="javascript:void(0)" style="color:#fff">
                    {{userName}}
                    <svg class="icon icon_down1" aria-hidden="true">
                      <use xlink:href="#icon-xiala1"></use>
                    </svg>
                </a>
                <i></i>
                <Dropdown-menu slot="list">
                    <!-- <Dropdown-item><a target="_blank" @click="openOuterPage(userUrl);return false">用户中心</a></Dropdown-item> -->
                    <Dropdown-item>
                      <a target="_blank" :href="$router.history.base+'/user'">
                        <span>{{$t('index.usercenter')}}</span>
                      </a>
                    </Dropdown-item>

                    <Dropdown-item>
                      <a class="switchTenant" @click="tenantListModalShow = true">
                        <span>切换租户</span>
                        <p class="omit">{{currentTname}}</p>
                      </a>
                    </Dropdown-item>
                    <!-- <Dropdown-item><a target="_blank" @click="openOuterPage(accountUrl);return false">费用中心</a></Dropdown-item> -->
                    <Dropdown-item v-if="hasQx">
                      <a target="_blank" :href="$router.history.base+'/governance'">
                        <span>{{$t('index.guideControl')}}</span>
                      </a>
                    </Dropdown-item>
                    <!-- <Dropdown-item><a :href="$router.history.base+'/AI/speechRecognition'" target="_blank">AI任务中心</a></Dropdown-item> -->
                    <Dropdown-item>
                      <a @click="logout();return false;">
                        <span>{{$t('index.exit')}}</span>
                      </a>
                    </Dropdown-item>
                </Dropdown-menu>
            </Dropdown>
            </MenuItem>
          </div>
          <div class="layout-menu">
            <ul class="menu-list clearfix">
              <li v-bind:class="{ active: menuActive.homepage}">
                <router-link to="/homepage">{{$t('index.homepage')}}</router-link>
              </li>
              <li v-bind:class="{ active: menuActive.live}" v-has="'daguan-live-module-open'">
                <router-link to="/live">{{$t('index.cloudLive')}}</router-link>
              </li>
              <li v-bind:class="{ active: menuActive.vod}" v-has="'daguan-vod-module-open'">
                <router-link to="/vod">{{$t('index.cloudDemand')}}</router-link>
              </li>
              <li v-bind:class="{ active: menuActive.production}" v-has="'daguan-manufacture-module-open'">
                <router-link to="/production">{{$t('index.cloudProd')}}</router-link>
              </li>
              <!-- <li v-bind:class="{ active: menuActive.microstation}" v-has="'daguan-microweb-module-open'">
                <router-link to="/microstation">{{$t('index.videoMs')}}</router-link>
              </li> -->
              <!--<li v-bind:class="{ active: menuActive.tvlive}">-->
                <!--<router-link to="/tvlive">电视直播</router-link>-->
              <!--</li>-->
              <!--  <li v-bind:class="{ active: menuActive.microstation}" v-has="'daguan-microweb-module-open'"><a @click="microLink">视频微站</a></li> -->
              <!--<li v-show="bsUserId == 1&&bsEditorShow==true"><a  @click="editorRedirect()">云非编</a></li>-->
              <!-- <template v-if="functionPass">
                <li v-has="'daguan-manufacture-editor-open'"><a  @click="editorRedirect()">云非编</a></li>
              </template> -->

              <!-- <li v-bind:class="{ active: menuActive.sportlive}">
                <router-link to="/sportlive">{{$t('index.livematches')}}</router-link>
              </li> -->
            </ul>
          </div>
        </Menu>
      </Header>
      <div style="flex: 1; overflow: auto">
        <router-view></router-view>
      </div>
    </Layout>

    <tenantListModal></tenantListModal>
  </div>
</template>
<script>
import tenantListModal from "../../views/common/tenantListModal"
//刷新token定时任务
var refreshTokenTimer = null;
  export default {
    components: {
      tenantListModal
    },
    data() {
      return {
        logoImg: require(`../../../static/assets/common/images/${process.env.logo_img_dir}/logo.png`),
        menuActive: {
          homepage: true,
          live: false,
          vod: false,
          production: false,
          microstation: false,
          tvlive: false,
          sportlive: false,
        },
        userName: "",
        tenantName: "",
        bsEditorUrl: "",
        bsEditorShow: false,
        bsTenantId: null,
        bsUserId: null,
        current_project_name: "",
        userKey: "",
        functionPass: false,

        tenantListModalShow: false,
        tenantList: [],
        currentTname: '',

        userUrl: process.env.user_url + "/views/user/user/user_center_page.html",
        accountUrl: process.env.user_url + "/views/user/user/user_account_center_page.html",
        topHeadShow:true,
        hasQx: sessionStorage.getItem('user_rights').includes('daguan-director-control-open')
      };
    },
    watch: {
      $route: function () {
        let currentRouter = this.$route.path;
        let path = currentRouter.split("/")[1];
        for (let key in this.menuActive) {
          this.menuActive[key] = false;
        }
        this.menuActive[path] = true;
      }
    },
    created() {
      //合成预览
      if(window.location.href.indexOf("/production/mosaic/preview/")>-1||window.location.href.indexOf("/zygkbigscreen")>-1||window.location.href.indexOf("/governance")>-1||window.location.href.indexOf("/user")>-1){
        this.topHeadShow = false;
      }
      this.getUserInfo();
      this.bsEditorShow = process.env.bs_editor_show;
      this.current_project_name = process.env.current_project_name;
      let currentRouter = this.$route.path;
      let path = currentRouter.split("/")[1];
      for (let key in this.menuActive) {
        this.menuActive[key] = false;
      }
      this.menuActive[path] = true;

      //获取多租户
      this.getTenants()
    },
    mounted() {
      //刷新token，5分钟刷新一次
      refreshTokenTimer = window.setInterval(this.refreshToken,1000*60*10);
      //refreshTokenTimer = window.setInterval(this.refreshToken,3000);
    },
    beforeDestroy() {
      // 清除token 刷新定时器
      if(refreshTokenTimer != null){
        window.clearInterval(refreshTokenTimer);
      }
    },
    methods: {
      toggleLang(lang) {
        if(lang == 'zh'){
          localStorage.setItem('lang', 'zh')
          this.$Message.success('切换为中文！')
        } else if (lang == 'en') {
          localStorage.setItem('lang', 'en')
          this.$Message.success('Switch to English!')
        }
        // this.$i18n.locale = localStorage.getItem('lang')
        window.location.reload();
      },
      // 路由跳转
      route(name) {
        this.$router.push(name);
      },

      getTenants() {
        this.$axios({
          method: "get",
          url: process.env.uc_server_url + "/console/tenant/current",
        }).then(response => {
          let result = response.data;
          if (result.status == 200) {
            if(result.data && result.data.length > 0) {
              this.tenantList = result.data
              this.tenantList.map(item => {
                if(item.tenantId == this.bsTenantId) this.currentTname = item.name
              })
            } else {
              this.tenantList = []
              this.currentTname = ''
            }
          } else {
            this.$selfError({
              content: result.message ? result.message : result.msg,
              errcode: result.status
            });
          }
        }).catch(error => {
          console.log(error);
          this.$Notice.error({
            title: this.$t('pub.sysYc')
          });
        });
      },


      //刷新token
      refreshToken(){
        let now = Date.now() + 1000 * 60 * 30;
        let expiredTime = this.$store.getters.getTokenExpiredTime;
        if (now > expiredTime) { //刷新过期时间
          this.$axios({
            method: "get",
            url: process.env.uc_server_url + "/login/refresh/token",
          }).then(result=>{
            var backData = result.data;
            if (backData.status == 200) {
              this.$store.dispatch('setToken', backData.data.token);
              if(backData.data.expired){
                this.$store.dispatch('setTokenExpiredTime', new Date(backData.data.expired).getTime());
              }
            }else {
//              this.$selfError({
//                content: backData.msg,
//                errcode: backData.status
//              });
              //退出登录
             // this.logout();
            }

          }).catch(err=>{
            console.error(err);
//            this.$Notice.error({
//              title: "系统异常"
//            });
            ////退出登录
           // this.logout();
          })

        }else{
          return;
        }
      },
      getUserInfo() {
        var userInfo = this.$store.getters.getUserInfo;
        this.userName = userInfo.loginUsername;
        this.bsTenantId = userInfo.tenantId;
        this.bsUserId = userInfo.loginUserId;
        this.tenantName = userInfo.tenantName;
        this.userKey = userInfo.userKey;
      },
      logout: function () {
        this.logoutUtil(process.env.user_url + "/logout");
        //移除session用户和token相关信息
        this.$store.commit("resetState");
        sessionStorage.clear();
        window.location.href =
          process.env.cas_url + "/logout?service=" + process.env.service_name;
        return false;
      },
      logoutUtil: function (url) {
        this.$axios({
          method: "get",
          url: url
        });
      },

      // 微站跳转
      microLink() {
        this.$axios({
          method: "get",
          url: process.env.microweb_api_url_prefix + "/mw/check"
        }).then(res => {
          var backData = res.data;
          if (backData.status == 200) {
            this.$router.push("/microstation/publish/" + backData.data.mwId);
          } else if (backData.status == 404) {
            this.$router.push("/microstation/new");
          } else {
            this.$selfError({
              content: backData.msg,
              errcode: backData.status
            });
          }
        }).catch(err => {
          console.error(err);
          this.$Notice.error({
            title: this.$t('pub.sysYc')
          });
        });
      },
      // 查询是否开通剪辑功能
      checkFunction(userKey) {
        let tm = Date.now();
        let sign = md5(tm + '' + this.bsUserId + userKey);
        this.$axios({
            method: "post",
            url: process.env.uc_api_url_prefix + "/api/v1/tenant/getRight?userid=" + this.bsUserId + "&tm=" + tm +
              "&sign=" + sign + "&tenantid=" + this.bsTenantId + "&serviceType=5",
          })
          .then(response => {
            var result = response.data;
            if (result.status == 200) {
              this.functionPass = true;
            } else if (result.status == 4009) {
              this.functionPass = false;
            } else {
              this.$selfError({
                content: result.msg,
                errcode: result.status
              });
            }
          })
          .catch(error => {
            console.log(error);
            this.$Notice.error({
              title: this.$t('pub.sysYc')
            });
          });
      },
      getUuid() {
        var len = 32; //32长度
        var radix = 16; //16进制
        var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
        var uuid = [],
          i;
        radix = radix || chars.length;
        if (len) {
          for (i = 0; i < len; i++)
            uuid[i] = chars[0 | Math.random() * radix];
        } else {
          var r;
          uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
          uuid[14] = '4';
          for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
              r = 0 | Math.random() * 16;
              uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
            }
          }
        }
        return uuid.join('');
      },
      // 云非编跳转
      editorRedirect() {
        var id = this.getUuid();
        this.$axios({
          method: "post",
          url: process.env.bs_editor_login_url + "api/tool/createProject",
          data: {
            createId: this.bsUserId,
            createUser: this.userName,
            description: "",
            id: id,
            projectName: "",
            tenantId: this.bsTenantId,
            token: this.userKey,
            workNo: ""
          }
        }).then(res => {
          var backData = res.data;
          if (backData.code == 200) {
            var token = backData.result.token;
            var agent = backData.result.agent;
            var url = process.env.bs_editor_url + "index?userUid=" + this.bsUserId + "&token=" + token +
              "&userName=" + this.userName + "&agent=" + agent + "&id=" + id;
            window.open(url);
          } else {
            this.$selfError({
              content: backData.message,
              errcode: backData.code
            });
          }
        }).catch(err => {
          console.error(err);
          this.$Notice.error({
            title: this.$t('pub.sysYc')
          });
        });
      },

      openOuterPage(outerUrl) {
        var userInfo = this.$store.getters.getUserInfo;
        var uid = userInfo.loginUserId;
        var tid = userInfo.tenantId
        let param = {};
        param.tid = tid;
        let tm = Date.now().toString();
        let userkey = this.$store.getters.getUserKey;
        let sign = md5(tm + uid + userkey);
        param.rs = sign;
        param["tm"] = tm;
        let url = outerUrl + "?uid=" + uid;
        for (let key in param) {
          url = url + "&" + key + "=" + param[key];
        }
        url = encodeURI(url);
        window.open(url);
      },
    },
  };

</script>


<style scoped>
  .layout.appMain {
    /* border: 1px solid #d7dde4; */
    background: #f5f7f9;
    position: relative;
    /* border-radius: 4px; */
    overflow: hidden;
    height: 100%;
  }

  .appMain .ivu-layout {
    height: 100%;
    background: #e9edf3;
  }

  .appMain .ivu-layout-content {
    height: auto;
  }
  .ivu-dropdown-item{
    padding: 0;
  }
  .ivu-dropdown-item a{
    display: inline-block;
    width: 100%;
    height: 100%;
    padding: 7px 16px;
  }
  .appMain .layout-con {
    height: 100%;
    width: 100%;
  }

  .appMain .menu-item span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    transition: width 0.2s ease 0.2s;
  }
  .userImg{
    vertical-align: middle;
    width: 41px;
    height: 41px;
    margin-right: 5px;
  }
  .icon_down1{
    margin-left: 5px;
  }
  .appMain .menu-item i {
    transform: translateX(-50%);
    transition: background 0.2s ease 0.2s;
  }

  .appMain .collapsed-menu span {
    width: 0px;
    transition: width 0.2s ease;
  }

  .appMain .collapsed-menu i {
    transform: translateX(5px);
    transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
    vertical-align: middle;
    font-size: 22px;
  }

  /*顶部样式*/

  .appMain .ivu-layout-header {
    /* height: 60px;
    line-height: 60px;
    background: #347fff; */
    padding: 0px;
    height: 91px;
    line-height: 91px;
    background: linear-gradient(90deg, #1D40CA 0%, #547CF1 100%);
  }

  .appMain .ivu-menu-horizontal {
    background-color: transparent;
    box-shadow: 0px 4px 8px 0px rgba(20, 36, 70, 0.2);
    height: 91px;
    line-height: 91px;
    background-image: url("../../../static/assets/common/images/nav_back.png");
  }

  .appMain .layout-logo {
    float: left;
    width: 246px;
    height: 91px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .layout-logo .back-to-home {
    display: inherit;
  }

  .layout-logo .back-to-home img {
    width: 156px;
  }

  .appMain .layout-menu {
    float: right;
    margin-left: 40px;
  }

  .menu-list>li {
    float: left;
    margin: 0 30px;
  }

  .menu-list>li>a {
    display: inline-block;
    padding: 0 2px;
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
    /* background-color: #347fff; */
    /* border-radius: 6px; */
    line-height: 18px;
    height: 91px;
    line-height: 91px;
  }

  .menu-list>li.active>a {
    color: #6FE2B8;
    border-bottom: 3px solid #6FE2B8;
  }

  .appMain .layout-nav {
    /* width: 100%; */
    float: right;
    background: rgba(255,255,255,.1);
    margin: 0px;
    margin-right: 0px;
  }

  .appMain .ivu-menu-horizontal .ivu-menu-item {
    font-size: 14px;
    color: #ffffff;
    padding: 0px 20px;
    float: right;
  }

  .appMain .ivu-menu-horizontal .ivu-menu-item .user-info {
    display: inline-block;
    min-width: 100px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    position: relative;
    padding: 0 10px;
  }

  .appMain .ivu-menu-horizontal .ivu-menu-item .user-info>i {
    display: inline-block;
    margin-left: 5px;
    width: 0;
    height: 0;
    border-top: solid 6px #ffffff;
    border-left: solid 6px transparent;
    border-right: solid 6px transparent;
    vertical-align: middle;
    transition: all 0.5s;
  }

  .appMain .ivu-menu-horizontal .ivu-menu-item .user-info:hover>i {
    transform: rotate(180deg);
  }

  .appMain .ivu-menu-horizontal .ivu-menu-item .user-info>ul {
    position: absolute;
    left: 0;
    width: 100%;
    height: 0;
    overflow: hidden;
    background-color: #347fff;
    border-radius: 0 0 8px 8px;
    transition: all 0.5s;
  }

  .appMain .ivu-menu-horizontal .ivu-menu-item .user-info:hover>ul {
    height: 160px;
  }

  .appMain .ivu-menu-horizontal .ivu-menu-item .user-info>ul>li {
    height: 40px;
    line-height: 40px;
  }

  .appMain .ivu-menu-horizontal .ivu-menu-item .user-info>ul>li>a {
    display: inline-block;
    width: 100%;
    height: 100%;
    color: #ffffff;
  }

  .appMain .ivu-menu-horizontal .ivu-menu-item .user-info>ul>li>a:hover {
    color: #cccccc;
  }

</style>
<style lang="less" scoped>
.lang{
  display: inline-block;
  font-size: 30px;
  vertical-align: middle;
  margin: 0 17px 0 20px;
  cursor: pointer;
}
.fengexian{
  display: inline-block;
  width: 1px;
  height: 34px;
  background: rgba(255,255,255,.2);
  vertical-align: middle;
}

.main-drop {
  /deep/ .ivu-select-dropdown {
    width: 140px;
    border-radius: 6px;
    padding: 6px 0;
    margin: 10px 0;

    .ivu-dropdown-item {
      >a {
        width: 140px;
        height: 40px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        padding: 0 20px;

        &.switchTenant {
          height: 50px;
        }
        
        >span {
          font-size: 14px;
          line-height: 14px;
          color: #333333;
        }

        >p {
          font-size: 12px;
          line-height: 12px;
          margin-top: 6px;
          color: rgba(51,51,51,0.7);
        }

        &:hover {
          background: rgba(235, 242, 252, 0.6);
          
          >span {
            color: #0B61DB;
          }
          >p {
            color: rgba(11,97,219,0.7);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/daguan/App.vue